import { useInsertionEffect, useRef } from 'react';
import { useSheet } from './SheetContext';
function createCacheKey(cssRuleTriple) {
  const [selector, __, mediaQuery] = cssRuleTriple;
  return `${!mediaQuery ? 'default' : mediaQuery}::${selector}`;
}
export default function useLiveUpdateCss(cssRuleTriple) {
  const sheet = useSheet();
  const selectorCache = useRef(new Map());
  useInsertionEffect(() => {
    const cache = selectorCache.current;
    const newCache = new Map();
    cssRuleTriple.forEach(triple => {
      const [selector, ruleset, mediaQuery] = triple;
      const cacheKey = createCacheKey(triple);
      newCache.set(cacheKey, [selector, mediaQuery !== null && mediaQuery !== void 0 ? mediaQuery : '']);
      cache.delete(cacheKey);
      if (sheet) {
        sheet.addRule(selector, ruleset, mediaQuery);
      }
    });
    // Clean up any rules that were removed from the previous render
    if (sheet) {
      for (const [selector, mediaQuery] of cache.values()) {
        sheet.deleteRule(selector, mediaQuery);
      }
    }
    selectorCache.current = newCache;
  }, [cssRuleTriple]);
}